import {Component, ErrorInfo, ReactNode} from 'react';
import NotFoundImage from '../../assets/image/404.png';
import Button from '../../components/button';

const hardReload = async () => {
  try {
    if ('serviceWorker' in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map(reg => reg.unregister()));
    }
    if ('caches' in window) {
      const keys = await caches.keys();
      await Promise.all(keys.map(key => caches.delete(key)));
    }
  } catch (err) {
    console.error('Failed to clear caches before hard reload', err);
  } finally {
    // cache-busting param forces a real network request for the document,
    // instead of a reload potentially served from memory/back-forward cache
    const url = new URL(window.location.href);
    url.searchParams.set('_hr', Date.now().toString());
    window.location.replace(url.toString());
  }
};

class AppErrorBoundary extends Component<
  {children: ReactNode},
  {hasError: boolean}
> {
  state = {hasError: false};
  static getDerivedStateFromError() {
    return {hasError: true};
  }
  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('App crashed:', error, info);
  }

  render() {
    if (this.state.hasError) {
      if (!sessionStorage.getItem('app-recovered')) {
        sessionStorage.setItem('app-recovered', '1');
        window.location.reload();
        return null;
      }

      return (
        <div className="flex flex-col justify-center w-full h-full px-3 bg-white align-center">
          <div className="flex flex-col items-center justify-center w-full gap-4">
            <img src={NotFoundImage} alt="page-not-found" />
            <p className="pb-0 mb-0 text-lg text-gray-800 font-Regular">
              مشکلی پیش آمده
            </p>
            <Button onClick={hardReload}>تلاش مجدد</Button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default AppErrorBoundary;
